/**
 * Headlight Platform Configuration — Master List association registry.
 *
 * The many-to-many joins between managed entities, GENERATED from the live schema graph
 * (lib/headlight_model/json/Headlight.json) by build-connections.js — see Connections.generated.js.
 * pict-section-recordset reads these (registered into its RecordSetAssociationManager) and a record's
 * read view shows an embedded Association editor tab for any recordset that opts in via `ReadTabs`
 * (defaulted per entity from the same generated file; see Headlight-MasterLists.js).
 *
 * Regenerate after a schema change or a Connection-Curation.js edit:
 *   node source/master-lists/build-connections.js
 *
 * The richer, runtime-context associations (Project↔ObservationManifest name-keyed synthesis + defaults,
 * Project↔User role scope) stay registered INLINE in PlatformConfiguration-Application-Web.js — they close
 * over the app's REST client, so they can't live in a static file. They are excluded from generation
 * (Connection-Curation.ExcludeJoins) so nothing collides.
 */

const { ASSOCIATIONS } = require('./Connections.generated.js');

module.exports = { ASSOCIATIONS };
